// src/components/contact/ContactMap.jsx
import React from "react";

const ContactMap = ({ googleMapUrl }) => {
  if (!googleMapUrl) return null;

  return (
    <div className="h-full min-h-[400px] w-full md:min-h-[500px]">
      <div className="panel-elevated flex h-full min-h-[400px] flex-col overflow-hidden rounded-2xl p-2 md:min-h-[500px] md:p-4">
        <div className="relative min-h-0 flex-1">
          <iframe
            src={googleMapUrl}
            title="CAS Systems Location"
            className="absolute inset-0 h-full w-full rounded-xl"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </div>
  );
};

export default ContactMap;


